import { render, staticRenderFns } from "./tama-registration-icon.vue?vue&type=template&id=3a77bda7"
import script from "./tama-registration-icon.vue?vue&type=script&lang=js"
export * from "./tama-registration-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports